function ProfileContainerController($scope, navigationService) {
  $scope.$watch(() => navigationService.currentNodeIdProfile, () => {
    $scope.currentNodeIdProfile = navigationService.currentNodeIdProfile;
  });

  $scope.expanded = false;
  $scope.toggleExpansion = () => {
    $scope.expanded = !$scope.expanded;
  };
}

const arr = [
  '$scope',
  'navigationService',
  ProfileContainerController
];

module.exports = (ngModule) => {
  ngModule.controller('ProfileContainerController', arr);
};
